<template>
  <v-row
    align="center"
    justify="center">
    <v-col md="8">
      <v-card :loading="loading">
        <v-card-title>
          {{ $t("crudActions.updateModel", { model: $t("models.domains.single") }) }}
        </v-card-title>
        <v-card-text>
          <validation-observer
            ref="validationObserver"
            slim>
            <domain-form
              v-model="domain"
              :params="params"
              :validations="validationRules"
              @submit="update" />
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="$router.push({ name: $routes.domain.indexRoute.name })">
              {{ $t("actions.back") }}
            </v-btn>
            <v-spacer />
            <v-btn
              color="success"
              @click="update">
              {{ $t("crudActions.update") }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { fetchParams, fetchDomain, updateDomain } from "@/api/domain.js";
import DomainForm from "../../components/domain/DomainForm.vue";
import ContentLoader from "../../mixins/ContentLoader.js";
import { ValidationObserver } from "vee-validate";
import Validatable from "../../mixins/Validatable.js";

export default {
  name: "DomainUpdate",
  components: {
    DomainForm,
    ValidationObserver,
  },
  mixins: [ContentLoader, Validatable],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      domain: {
        url: null,
        style: null,
      },
      params: {
        styles: [],
      },
    };
  },
  computed: {
    validationRules() {
      return {
        url: "required",
        style: "required",
      };
    },
  },
  created() {
    this.$startLoading();
    const paramsPromise = fetchParams().
      then(({ data }) => {
        this.params.styles = data.styles;
      });
    const fetchPromise = fetchDomain(this.id).
      then(({ data }) => {
        this.domain.url = data.domain.url;
        this.domain.style = data.domain.style;
      });
    Promise.all([paramsPromise, fetchPromise]).
      finally(() => {
        this.$finishedLoading();
      });
  },
  methods: {
    update() {
      this.$refs.validationObserver.validate().
        then(isValid => {
          if (isValid) {
            this.$startLoading();
            updateDomain(this.id, this.domain).
              then(() => {
                this.$router.push({ name: this.$routes.domain.indexRoute.name });
              }).
              catch(error => this.handleErrorResponse(this.$refs.validationObserver, error)).
              finally(() => {
                this.$finishedLoading();
              });
          }
        });
    },
  },
};
</script>
